__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "maropost-frontend";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@amplitude/analytics-browser", "2.37.1", () => (Promise.all([__webpack_require__.e("node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("node_modules_amplitude_analytics-browser_lib_esm_index_js")]).then(() => (() => (__webpack_require__(/*! ./node_modules/@amplitude/analytics-browser/lib/esm/index.js */ "./node_modules/@amplitude/analytics-browser/lib/esm/index.js"))))));
			register("@splitsoftware/splitio", "11.11.0", () => (Promise.all([__webpack_require__.e("node_modules_tslib_tslib_es6_mjs"), __webpack_require__.e("node_modules_splitsoftware_splitio_esm_index_js")]).then(() => (() => (__webpack_require__(/*! ./node_modules/@splitsoftware/splitio/esm/index.js */ "./node_modules/@splitsoftware/splitio/esm/index.js"))))));
			register("pinia", "3.0.4", () => (Promise.all([__webpack_require__.e("webpack_sharing_consume_default_vue_vue"), __webpack_require__.e("node_modules_pinia_dist_pinia_mjs")]).then(() => (() => (__webpack_require__(/*! ./node_modules/pinia/dist/pinia.mjs */ "./node_modules/pinia/dist/pinia.mjs"))))));
			register("vue", "3.5.29", () => (__webpack_require__.e("node_modules_vue_dist_vue_runtime_esm-bundler_js").then(() => (() => (__webpack_require__(/*! ./node_modules/vue/dist/vue.runtime.esm-bundler.js */ "./node_modules/vue/dist/vue.runtime.esm-bundler.js"))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};